// extracted by mini-css-extract-plugin
export default {"wrapper":"J1KFzoNVUk6Xg3HeTac7","closable":"fLSJImGsIWejK60HMmLk","crossIcon":"_YhvzR74NXi5w1_ZnlwE"};